import { CrosswordInput } from '../types';

const crosswords: CrosswordInput[] = [
    // 1
  {
    author: 'முகிலன் முருகன்',
    across: {
      '1': {
        answer: 'உலகம்',
        row: 0,
        col: 0,
      },
      '2': {
        answer: 'அறிவியல்',
        row: 2,
        col: 0,
      },
      '3': {
        answer: 'மாமன்றம்',
        row: 4,
        col: 0,
      },
    },
    down: {
      '4': {
        answer: 'கல்விமான்',
        row: 0,
        col: 2,
      },
      '2': {
        answer: 'அம்மா',
        row: 2,
        col: 0,
      },
      '5': {
        answer: 'செல்வம்',
        row: 1,
        col: 4,
      },
    },
  },
  // 2
  {
    author: 'முகிலன் முருகன்',
    across: {
      '4': {
        answer: 'அன்பு',
        row: 0,
        col: 2,
      },
      '2': {
        answer: 'செங்காற்று',
        row: 2,
        col: 0,
      },
      '3': {
        answer: 'திறம்',
        row: 4,
        col: 0,
      },
    },
    down: {
      '1': {
        answer: 'நற்செய்தி',
        row: 0,
        col: 0,
      },
      '4': {
        answer: 'அதிகாரம்',
        row: 0,
        col: 2,
      },
      '5': {
        answer: 'புற்றுநோய்',
        row: 0,
        col: 4,
      },
    }
  },
  // 3
  {
    author: 'இளமாறன் நாகலிங்கம்',
    across: {
      '1': {
        answer: 'படிமம்',
        row: 0,
        col: 0,
      },
      '2': {
        answer: 'பாத்திரம்',
        row: 2,
        col: 0,
      },
      '3': {
        answer: 'அம்பு',
        row: 4,
        col: 1,
      }
    },
    down: {
      '1': {
        answer: 'பண்பாடு',
        row: 0,
        col: 0,
      },
      '4': {
        answer: 'மந்திரம்',
        row: 0,
        col: 2,
      },
      '5': {
        answer: 'தம்பி',
        row: 1,
        col: 4,
      }
    }
  },
  // 4
  {
    author: 'தமிழ் இனியன் பஞ்சு',
    across: {
        '1': {
            answer: 'கண்காட்சி',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'வெளிச்சம்',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'பாடல்',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'கலிவெண்பா',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'காய்ச்சல்',
            row: 0,
            col: 2
        },
        '5': {
            answer: 'சிலம்பம்',
            row: 0,
            col: 4
        }
    }
  },
    // 5
    {
      author: 'முகிலன் முருகன்',
      across: {
          '4': {
              answer: 'மனைவி',
              row: 0,
              col: 2
          },
          '2': {
              answer: 'கூடாநட்பு',
              row: 2,
              col: 0
          },
          '3': {
              answer: 'கும்பம்',
              row: 4,
              col: 1
          }
      },
      down: {
          '1': {
              answer: 'உட்கூறு',
              row: 0,
              col: 0
          },
          '4': {
              answer: 'மனநலம்',
              row: 0,
              col: 2
          },
          '5': {
              answer: 'விளைபுலம்',
              row: 0,
              col: 4
          }
      }
    },
        // 6
        {
          author: 'முல்லை இராதா',
          across: {
              '1': {
                  answer: 'இறைமாட்சி',
                  row: 0,
                  col: 0
              },
              '2': {
                  answer: 'வண்டையர்',
                  row: 2,
                  col: 0
              },
              '3': {
                  answer: 'கோபுரம்',
                  row: 4,
                  col: 1
              }
          },
          down: {
              '1': {
                  answer: 'இறைவன்',
                  row: 0,
                  col: 0
              },
              '4': {
                  answer: 'மாரடைப்பு',
                  row: 0,
                  col: 2
              },
              '5': {
                  answer: 'சிலர்',
                  row: 0,
                  col: 4
              }
          }
        },
   // 7
   {
    author: 'முல்லை இராதா',
    across: {
        '1': {
            answer: 'கவரிமான்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'தடு',
            row: 1,
            col: 0
        },
        '3': {
            answer: 'பங்கு',
            row: 2,
            col: 2
        },
        '4': {
          answer: 'பயிலகம்',
          row: 3,
          col: 0
      },
      '5': {
        answer: 'கைம்மை',
        row: 4,
        col: 2
    }
    },
    down: {
        '1': {
            answer: 'கதம்பம்',
            row: 0,
            col: 0
        },
        '6': {
            answer: 'வடு',
            row: 0,
            col: 1
        },
        '3': {
            answer: 'பலகை',
            row: 2,
            col: 2
        },
        '7': {
          answer: 'மாமாங்கம்',
          row: 0,
          col: 3
      },
      '8': {
        answer: 'கும்மை',
        row: 2,
        col: 4
    }
    }
  },
   // 8
   {
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'மங்கை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'பிற்பகுதி',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'விழுதுகள்',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'மறுபிறவி',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'கைப்பந்து',
            row: 0,
            col: 2
        },
        '5': {
            answer: 'விடுதியாள்',
            row: 0,
            col: 4
        }
    }
  },
  // 9
  {
    author: 'சுஜாதா அன்பழகன்',
    across: {
        '1': {
            answer: 'நகராட்சி',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'கைதி',
            row: 1,
            col: 0
        },
        '3': {
            answer: 'வைத்தியம்',
            row: 4,
            col: 0
        },
        '4': {
          answer: 'பரிதி',
          row: 2,
          col: 2
      }
    },
    down: {
        '1': {
            answer: 'நகைச்சுவை',
            row: 0,
            col: 0
        },
        '5': {
            answer: 'கதி',
            row: 0,
            col: 1
        },
        '4': {
            answer: 'பந்தி',
            row: 2,
            col: 2
        },
        '6': {
          answer: 'சித்திரம்',
          row: 0,
          col: 4
      }
    }
  },
  // 10
  {
    author: 'சுஜாதா அன்பழகன்',
    across: {
        '1': {
            answer: 'பூப்பந்து',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'தகர்ப்பு',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'புனைவு',
            row: 4,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'பூந்தளிர்',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'பயிர்ப்பு',
            row: 0,
            col: 2
        },
        '5': {
            answer: 'துப்புரவு',
            row: 0,
            col: 4
        }
    }
  },
   // 11
   {
    author: 'முல்லை இராதா',
    across: {
        '1': {
            answer: 'பொதுநலம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'சாம்பல்',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'புயல்மழை',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'பொச்சாப்பு',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'நண்பகல்',
            row: 0,
            col: 2
        },
        '5': {
            answer: 'வாழை',
            row: 3,
            col: 4
        }
    }
  },
   // 12
   {
    author: 'சுஜாதா அன்பழகன்',
    across: {
        '1': {
            answer: 'தாமரைப்பூ',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'பம்பரம்',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'கைத்திறம்',
            row: 4,
            col: 0
        }
    },
    down: {
        '2': {
            answer: 'பலகை',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'மனம்',
            row: 0,
            col: 1
        },
        '5': {
            answer: 'பந்தி',
            row: 2,
            col: 2
        },
        '6': {
          answer: 'பூகம்பம்',
          row: 0,
          col: 4
      }
    }
  },
    // 13
    {
      author: 'சுஜாதா அன்பழகன்',
      across: {
          '1': {
              answer: 'முதலுதவி',
              row: 0,
              col: 0
          },
          '2': {
              answer: 'காப்புறுதி',
              row: 2,
              col: 0
          },
          '3': {
              answer: 'கடைவெள்ளி',
              row: 4,
              col: 0
          },
          '4': {
              answer: 'வடு',
              row: 1,
              col: 3
          }
      },
      down: {
          '5': {
              answer: 'தரைப்படை',
              row: 0,
              col: 1
          },
          '6': {
              answer: 'தவறுகள்',
              row: 0,
              col: 3
          },
          '7': {
              answer: 'விடுதி',
              row: 0,
              col: 4
          }
      }
    },
      // 14
   {
    author: 'சுஜாதா அன்பழகன்',
    across: {
        '1': {
            answer: 'இருவாச்சி',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'பத்திரம்',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'குடும்பம்',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'இருபங்கு',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'வாத்தியம்',
            row: 0,
            col: 2
        },
        '5': {
            answer: 'சிலம்பம்',
            row: 0,
            col: 4
        }
    }
  },
    // 15
    {
        author: 'முல்லை இராதா',
        across: {
            '1': {
                answer: 'வணக்கம்',
                row: 0,
                col: 0
            },
            '2': {
                answer: 'வட்டாரம்',
                row: 3,
                col: 0
            },
            '3': {
                answer: 'ஆவது',
                row: 2,
                col: 2
            },
            '4': {
                answer: 'தம்பி',
                row: 4,
                col: 2
            }
        },
        down: {
            '1': {
                answer: 'வள்ளுவம்',
                row: 0,
                col: 0
            },
            '5': {
                answer: 'கலவரம்',
                row: 0,
                col: 3
            },
            '3': {
                answer: 'ஆடாத',
                row: 2,
                col: 2
            },
            '6': {
                answer: 'தும்பி',
                row: 2,
                col: 4
            }
        }
      },
 // 16
 {
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'அறிமுகம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'வாழ்நிலை',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'துணிவுடைமை',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'அறிவானது',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'முழுநிலவு',
            row: 0,
            col: 2
        },
        '5': {
            answer: 'ஆமை',
            row: 3,
            col: 4
        }
    }
  },
     // 17
     {
        author: 'முல்லை இராதா',
        across: {
            '1': {
                answer: 'அத்திப்பூ',
                row: 0,
                col: 0
            },
            '2': {
                answer: 'மதுபானம்',
                row: 3,
                col: 0
            }
        },
        down: {
            '1': {
                answer: 'அரண்மனை',
                row: 0,
                col: 0
            },
            '3': {
                answer: 'திருப்பாவை',
                row: 0,
                col: 2
            },
            '4': {
                answer: 'பூமணம்',
                row: 0,
                col: 4
            }
        }
      },
       // 18
     {
        author: 'முல்லை இராதா',
        across: {
            '1': {
                answer: 'சித்திரம்',
                row: 0,
                col: 0
            },
            '2': {
                answer: 'கணக்கர்',
                row: 2,
                col: 0
            },
            '3': {
                answer: 'ஔவையார்',
                row: 4,
                col: 1
            }
        },
        down: {
            '1': {
                answer: 'சிறுகதை',
                row: 0,
                col: 0
            },
            '4': {
                answer: 'திருக்கோவை',
                row: 0,
                col: 2
            }
        }
      },
      // 19
     {
        author: 'அமுதவல்லி நாராயணன்',
        across: {
            '1': {
                answer: 'மகரயாழ்',
                row: 0,
                col: 0
            },
            '2': {
                answer: 'திரி',
                row: 1,
                col: 0
            },
            '3': {
                answer: 'முயல்',
                row: 2,
                col: 0
            },
            '4': {
                answer: 'நனி',
                row: 3,
                col: 3
            },
            '5': {
                answer: 'கடுமை',
                row: 4,
                col: 2
            }
        },
        down: {
            '1': {
                answer: 'மதிமுகம்',
                row: 0,
                col: 0
            },
            '6': {
                answer: 'கரிய',
                row: 0,
                col: 1
            },
            '4': {
                answer: 'நடு',
                row: 3,
                col: 3
            },
            '7': {
                answer: 'இனிமை',
                row: 2,
                col: 4
            }
        }
      },
      // 20
     {
        author: 'முல்லை இராதா',
        across: {
            '1': {
                answer: 'கருவாடு',
                row: 0,
                col: 0
            },
            '2': {
                answer: 'கருமயிர்',
                row: 2,
                col: 0
            },
            '3': {
                answer: 'பாம்பு',
                row: 4,
                col: 1
            }
        },
        down: {
            '1': {
                answer: 'கழகம்',
                row: 0,
                col: 0
            },
            '4': {
                answer: 'வாழைமரம்',
                row: 0,
                col: 2
            },
            '5': {
                answer: 'பார்வை',
                row: 1,
                col: 4
            }
        }
      },
      // 21
     {
        author: 'முகிலன் முருகன்',
        across: {
            '1': {
                answer: 'மாண்புமிகு',
                row: 0,
                col: 0
            },
            '2': {
                answer: 'கருமரம்',
                row: 2,
                col: 0
            },
            '3': {
                answer: 'கம்பம்',
                row: 4,
                col: 1
            }
        },
        down: {
            '1': {
                answer: 'மாங்கனி',
                row: 0,
                col: 0
            },
            '4': {
                answer: 'புதுமணம்',
                row: 0,
                col: 2
            },
            '5': {
                answer: 'குடும்பம்',
                row: 0,
                col: 4
            }
        }
      },
      // 22
     {
        author: 'முகிலன் முருகன்',
        across: {
            '1': {
                answer: 'காகிதப்பூ',
                row: 0,
                col: 0
            },
            '2': {
                answer: 'நறுமனம்',
                row: 2,
                col: 0
            },
            '3': {
                answer: 'குடும்பம்',
                row: 4,
                col: 0
            }
        },
        down: {
            '2': {
                answer: 'நல்கு',
                row: 2,
                col: 0
            },
            '4': {
                answer: 'தலமரம்',
                row: 0,
                col: 2
            },
            '5': {
                answer: 'பூகம்பம்',
                row: 0,
                col: 4
            }
        }
      },
      // 23
     {
        author: 'முகிலன் முருகன்',
        across: {
            '1': {
                answer: 'வெகுமதி',
                row: 0,
                col: 0
            },
            '2': {
                answer: 'காரைக்குடி',
                row: 2,
                col: 0
            },
            '3': {
                answer: 'கைபிடி',
                row: 4,
                col: 2
            }
        },
        down: {
            '1': {
                answer: 'வெங்காயம்',
                row: 0,
                col: 0
            },
            '4': {
                answer: 'மரக்குகை',
                row: 0,
                col: 2
            },
            '5': {
                answer: 'அடிமுடி',
                row: 1,
                col: 4
            }
        }
      },
      // 24
     {
        author: 'கார்த்திக் வே',
        across: {
            '1': {
                answer: 'காட்டுத்தீ',
                row: 0,
                col: 0
            },
            '2': {
                answer: 'அம்மா',
                row: 2,
                col: 2
            },
            '3': {
                answer: 'துணிவு',
                row: 4,
                col: 0
            }
        },
        down: {
            '1': {
                answer: 'காற்பந்து',
                row: 0,
                col: 0
            },
            '2': {
                answer: 'அளவு',
                row: 2,
                col: 2
            },
            '4': {
                answer: 'தீர்மானம்',
                row: 0,
                col: 4
            }
        }
      },
      // 25
     {
        author: 'சரண் சரவணன்',
        across: {
            '1': {
                answer: 'கனிமம்',
                row: 0,
                col: 0
            },
            '2': {
                answer: 'பிதா',
                row: 2,
                col: 0
            },
            '3': {
                answer: 'கம்பளம்',
                row: 4,
                col: 0
            },
            '4': {
                answer: 'ஆணை',
                row: 2,
                col: 3
            }
        },
        down: {
            '1': {
                answer: 'கம்பி',
                row: 0,
                col: 0
            },
            '5': {
                answer: 'தாகம்',
                row: 2,
                col: 1
            },
            '6': {
                answer: 'மழை',
                row: 0,
                col: 2
            },
            '7': {
                answer: 'இணையம்',
                row: 1,
                col: 4
            }
        }
      },
       // 26
     {
        author: 'கார்த்திக் வே',
        across: {
            '1': {
                answer: 'பயன்பாடு',
                row: 0,
                col: 0
            },
            '2': {
                answer: 'பாகற்காய்',
                row: 2,
                col: 0
            },
            '3': {
                answer: 'நுனிப்புல்',
                row: 4,
                col: 0
            }
        },
        down: {
            '4': {
                answer: 'கணினி',
                row: 2,
                col: 1
            },
            '5': {
                answer: 'பாதுகாப்பு',
                row: 0,
                col: 3
            }
        }
      },
      // 27
     {
        author: 'முகிலன் முருகன்',
        across: {
            '1': {
                answer: 'மேற்கல்வி',
                row: 0,
                col: 0
            },
            '2': {
                answer: 'நிலவேம்பு',
                row: 2,
                col: 0
            },
            '3': {
                answer: 'கோபுரம்',
                row: 4,
                col: 1
            }
        },
        down: {
            '1': {
                answer: 'மேல்நிலை',
                row: 0,
                col: 0
            },
            '4': {
                answer: 'கறிவேம்பு',
                row: 0,
                col: 2
            },
            '5': {
                answer: 'விளைபுலம்',
                row: 0,
                col: 4
            }
        }
      },
      // 28
     {
        author: 'முல்லை இராதா',
        across: {
            '1': {
                answer: 'திறன்பேசி',
                row: 0,
                col: 0
            },
            '2': {
                answer: 'மதுபானம்',
                row: 2,
                col: 0
            },
            '3': {
                answer: 'கடிதம்',
                row: 3,
                col: 0
            }
        },
        down: {
            '1': {
                answer: 'திருமகள்',
                row: 0,
                col: 0
            },
            '4': {
                answer: 'துடி',
                row: 2,
                col: 1
            },
            '5': {
                answer: 'பாதம்',
                row: 2,
                col: 2
            },
            '6': {
                answer: 'பேரினம்',
                row: 0,
                col: 3
            }
        }
      },
            // 29
     {
        author: 'முகிலன் முருகன்',
        across: {
            '1': {
                answer: 'ஆடுகளம்',
                row: 0,
                col: 0
            },
            '2': {
                answer: 'திடல்',
                row: 2,
                col: 0
            },
            '3': {
                answer: 'நீளம்',
                row: 3,
                col: 2
            }
        },
        down: {
            '1': {
                answer: 'ஆத்திசூடி',
                row: 0,
                col: 0
            },
            '4': {
                answer: 'கடல்நீர்',
                row: 0,
                col: 2
            },
            '5': {
                answer: 'அம்மி',
                row: 2,
                col: 4
            }
        }
      },
     // 30
     {
        author: 'தமிழ்வேல் தணிகைவேல்',
        across: {
            '1': {
                answer: 'எஃகு',
                row: 0,
                col: 0
            },
            '2': {
                answer: 'வாக்குரிமை',
                row: 2,
                col: 0
            },
            '3': {
                answer: 'கும்பம்',
                row: 4,
                col: 1
            }
        },
        down: {
            '1': {
                answer: 'எழுவாய்',
                row: 0,
                col: 0
            },
            '4': {
                answer: 'குங்குமம்',
                row: 0,
                col: 2
            },
            '5': {
                answer: 'வெளிமையம்',
                row: 0,
                col: 4
            }
        }
      },
      // 31
     {
        author: 'தமிழ்வேல் தணிகைவேல்',
        across: {
            '1': {
                answer: 'குச்சி',
                row: 0,
                col: 0
            },
            '2': {
                answer: 'பதவி',
                row: 2,
                col: 2
            },
            '3': {
                answer: 'கைத்திறம்',
                row: 4,
                col: 0
            }
        },
        down: {
            '1': {
                answer: 'குறுந்தொகை',
                row: 0,
                col: 0
            },
            '4': {
                answer: 'சிப்பந்தி',
                row: 0,
                col: 2
            },
            '5': {
                answer: 'கருவிளம்',
                row: 0,
                col: 4
            }
        }
      },
 // 32
     {
        author: 'தமிழ்வேல் தணிகைவேல்',
        across: {
            '1': {
                answer: 'பேரகராதி',
                row: 0,
                col: 0
            },
            '2': {
                answer: 'சுட்டறிவு',
                row: 2,
                col: 0
            },
            '3': {
                answer: 'குளம்பி',
                row: 4,
                col: 0
            }
        },
        down: {
            '1': {
                answer: 'பேச்சு',
                row: 0,
                col: 0
            },
            '4': {
                answer: 'கட்டடம்',
                row: 0,
                col: 2
            },
            '5': {
                answer: 'திருவுரு',
                row: 0,
                col: 4
            }
        }
      },
 // 33
 {
    author: 'தமிழ்வேல் தணிகைவேல்',
    across: {
        '1': {
            answer: 'நீர்வேட்கை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'நெம்புகோல்',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'நரம்பு',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'நீதிநெறி',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'வேம்பு',
            row: 0,
            col: 2
        },
        '5': {
            answer: 'கோணம்',
            row: 2,
            col: 3
        }
    }
  },
  // 34
 {
    author: 'தமிழ்வேல் தணிகைவேல்',
    across: {
        '1': {
            answer: 'எதுகை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'துவர்ப்பு',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'ஒடுக்கம்',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'எனது',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'கைவார்',
            row: 0,
            col: 2
        },
        '5': {
            answer: 'வண்டு',
            row: 2,
            col: 1
        },
        '6': {
            answer: 'செம்புலம்',
            row: 0,
            col: 4
        }
    }
  },
 // 35
        {
            author: 'கார்த்திக் வே',
            across: {
                '1': {
                    answer: 'நகைச்சுவை',
                    row: 0,
                    col: 0
                },
                '2': {
                    answer: 'காப்பியம்',
                    row: 2,
                    col: 0
                },
                '3': {
                    answer: 'கும்மாளம்',
                    row: 4,
                    col: 0
                }
            },
            down: {
                '4': {
                    answer: 'கையொப்பம்',
                    row: 0,
                    col: 1
                },
                '5': {
                    answer: 'வையம்',
                    row: 0,
                    col: 4
                }
            }
          },
// 36
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'உயிர்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'தொகு',
            row: 1,
            col: 3
        },
        '3': {
            answer: 'கல்வெட்டு',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'குடிமை',
            row: 3,
            col: 2
        },
        '5': {
            answer: 'கோளில்',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'உலகம்',
            row: 0,
            col: 0
        },
        '6': {
            answer: 'வெகுளி',
            row: 2,
            col: 2
        },
        '2': {
            answer: 'தொட்டில்',
            row: 1,
            col: 3
        },
        '7': {
            answer: 'குடுமை',
            row: 1,
            col: 4
        }
    }
  },
   // 37
   {
    author: 'கார்த்திக் வே',
    across: {
        '1': {
            answer: 'உற்பத்தி',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'துளிர்',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'உள்குத்து',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'பங்காளர்',
            row: 0,
            col: 2
        },
        '4': {
            answer: 'தித்திப்பு',
            row: 0,
            col: 4
        }
    }
  },
   // 38
   {
    author: 'கார்த்திக் வே',
    across: {
        '1': {
            answer: 'பச்சரிசி',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'பழச்சாறு',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'சுவரொட்டி',
            row: 4,
            col: 0
        }
    },
    down: {
        '4': {
            answer: 'சிற்றுண்டி',
            row: 0,
            col: 4
        },
        '2': {
            answer: 'பஞ்சு',
            row: 2,
            col: 0
        }
    }
  },
     // 39
     {
        author: 'கார்த்திக் வே',
        across: {
            '1': {
                answer: 'மிதிவண்டி',
                row: 2,
                col: 0
            }
        },
        down: {
            '2': {
                answer: 'எலுமிச்சை',
                row: 0,
                col: 0
            },
            '3': {
                answer: 'குறவஞ்சி',
                row: 0,
                col: 2
            },
            '4': {
                answer: 'பட்டினம்',
                row: 0,
                col: 4
            }
        }
      },
 // 40
 {
    author: 'கார்த்திக் வே',
    across: {
        '1': {
            answer: 'நாடகம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'கானல்நீர்',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'கன்னம்',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'நாற்காலி',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'கடல்மீன்',
            row: 0,
            col: 2
        },
        '5': {
            answer: 'ஆர்வம்',
            row: 1,
            col: 4
        }
    }
  },
 // 41
 {
    author: 'கார்த்திக் வே',
    across: {
        '2': {
            answer: 'வருமானம்',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'தெற்கு',
            row: 0,
            col: 2
        },
        '4': {
            answer: 'வகுப்பு',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'உருவம்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'தெம்மாங்கு',
            row: 0,
            col: 2
        },
        '5': {
            answer: 'குணம்',
            row: 0,
            col: 4
        }
    }
  },
  // 42
 {
    author: 'கார்த்திக் வே',
    across: {
        '1': {
            answer: 'பூச்செண்டு',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'வல்லினம்',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'உயர்திணை',
            row: 4,
            col: 0
        }
    },
    down: {
        '4': {
            answer: 'செவிலியர்',
            row: 0,
            col: 2
        }
    }
  },
  // 43
  {
    author: 'கார்த்திக் வே',
    across: {
        '1': {
            answer: 'ஊர்வலம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'கல்லுப்பு',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'வளர்பிறை',
            row: 4,
            col: 0
        }
    },
    down: {
        '4': {
            answer: 'வல்லுநர்',
            row: 0,
            col: 2
        }
    }
  },
 // 44
 {
    author: 'கார்த்திக் வே',
    across: {
        '1': {
            answer: 'நிலபுலம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'பறிமுதல்',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'குறைகுடம்',
            row: 4,
            col: 0
        }
    },
    down: {
        '2': {
            answer: 'படகு',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'புறமுதுகு',
            row: 0,
            col: 2
        }
    }
  },
// 45
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'தக்காளி',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'கம்பரிசி',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'ஐம்முனை',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'தங்கம்',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'காப்பகம்',
            row: 0,
            col: 2
        },
        '5': {
            answer: 'ஊசிமுனை',
            row: 1,
            col: 4
        }
    }
  },
  // 46
{
    author: 'சாந்தா சுப்பிரமணியம்',
    across: {
        '1': {
            answer: 'வெகுமதி',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'காற்புள்ளி',
            row: 2,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'வெங்காயம்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'மரபுடைமை',
            row: 0,
            col: 2
        },
        '4': {
            answer: 'வளிமம்',
            row: 1,
            col: 4
        }
    }
  },
  // 47
  {
    author: 'சாந்தா சுப்பிரமணியம்',
    across: {
        '1': {
            answer: 'நாள்காட்டி',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'கரைச்சல்',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'வல்லாரை',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'நாடகம்',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'காய்ச்சல்',
            row: 0,
            col: 2
        }
    }
  },
 // 48
    {
        author: 'சாந்தா சுப்பிரமணியம்',
        across: {
            '1': {
                answer: 'சந்திப்பு',
                row: 0,
                col: 0
            },
            '2': {
                answer: 'வசதி',
                row: 2,
                col: 2
            },
            '3': {
                answer: 'குள்ளன்',
                row: 4,
                col: 1
            }
        },
        down: {
            '1': {
                answer: 'சமயம்',
                row: 0,
                col: 0
            },
            '4': {
                answer: 'திருவருள்',
                row: 0,
                col: 2
            },
            '5': {
                answer: 'புத்திமான்',
                row: 0,
                col: 4
            }
        }
      },
// 49
{
    author: 'கார்த்திக் வே',
    across: {
        '1': {
            answer: 'உறவினர்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'திரைக்கதை',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'வேண்டுதல்',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'உறுதி',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'விழுக்காடு',
            row: 0,
            col: 2
        },
        '5': {
            answer: 'தையல்',
            row: 2,
            col: 4
        }
    }
  },
  // 50
{
    author: 'கார்த்திக் வே',
    across: {
        '1': {
            answer: 'தலைநகர்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'மாவட்டம்',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'அம்பு',
            row: 4,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'தன்மானம்',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'கட்டணம்',
            row: 0,
            col: 3
        }
    }
  },
  // 51
  {
    author: 'தமிழ்க்கதிர் சரவணன்',
    across: {
        '1': {
            answer: 'கபடி',
            row: 1,
            col: 0
        },
        '2': {
            answer: 'குங்குமம்',
            row: 4,
            col: 0
        },
        '3': {
            answer: 'வருக',
            row: 2,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'கணக்கு',
            row: 1,
            col: 0
        },
        '4': {
            answer: 'வடிவழகு',
            row: 0,
            col: 2
        },
        '5': {
            answer: 'சங்கமம்',
            row: 0,
            col: 4
        }
    }
  },
// 52
{
    author: 'முல்லை இராதா',
    across: {
        '1': {
            answer: 'மகிழ்ச்சி',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'வண்மை',
            row: 3,
            col: 0
        },
        '3': {
            answer: 'அகதி',
            row: 2,
            col: 2
        },
        '4': {
            answer: 'திடம்',
            row: 4,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'மன்னவன்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'அமைதி',
            row: 2,
            col: 2
        },
        '5': {
            answer: 'சித்திரம்',
            row: 0,
            col: 4
        }
    }
  },
// 53
{
    author: 'முல்லை இராதா',
    across: {
        '1': {
            answer: 'சிங்கம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'கடுகு',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'திறமை',
            row: 3,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'சிக்கனம்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'குதிரை',
            row: 2,
            col: 2
        },
        '5': {
            answer: 'எளிமை',
            row: 1,
            col: 4
        }
    }
  },
  // 54
{
    author: 'முல்லை இராதா',
    across: {
        '1': {
            answer: 'சூரியன்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'திருமணம்',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'புலம்',
            row: 4,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'சூத்திரம்',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'மரபு',
            row: 2,
            col: 2
        },
        '5': {
            answer: 'கும்பம்',
            row: 1,
            col: 4
        }
    }
  },
  // 55
  {
    author: 'முல்லை இராதா',
    across: {
        '1': {
            answer: 'வணக்கம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'வேட்பாளர்',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'புதைகுழி',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'வரவேற்பு',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'கள்ளவிழி',
            row: 0,
            col: 3
        }
    }
  },
// 56
{
    author: 'முல்லை இராதா',
    across: {
        '1': {
            answer: 'பிள்ளை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'புத்தகம்',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'அடிமை',
            row: 4,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'பின்புலம்',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'கரடி',
            row: 2,
            col: 3
        },
        '5': {
            answer: 'பழம்',
            row: 0,
            col: 4
        }
    }
  },
  // 57
{
    author: 'முல்லை இராதா',
    across: {
        '1': {
            answer: 'மீன்கொத்தி',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'புதுமுகம்',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'புயல்மழை',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'மீட்பு',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'கொள்முதல்',
            row: 0,
            col: 2
        },
        '5': {
            answer: 'திறம்',
            row: 0,
            col: 4
        }
    }
  },
    // 58
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'மகிழ்ச்சி',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'திரிபு',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'துப்பு',
            row: 3,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'மந்திரம்',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'புதுமை',
            row: 2,
            col: 2
        },
        '5': {
            answer: 'சிரிப்பு',
            row: 0,
            col: 4
        }
    }
  },
 // 59
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'புலவர்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'கைவிளக்கு',
            row: 3,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'புன்னகை',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'வலைதளம்',
            row: 0,
            col: 2
        },
        '4': {
            answer: 'அறிகுறி',
            row: 1,
            col: 4
        }
    }
  },
// 60
      {
        author: 'முகுந்தன் (சிங்கப்பூர்)',
        theme: 'இல்லறம்',
        across: {
            '2': {
                answer: 'மணமகள்',
                row: 2,
                col: 0
            }
        },
        down: {
            '1': {
                answer: 'திருமணம்',
                row: 0,
                col: 0
            },
            '3': {
                answer: 'மணமகன்',
                row: 0,
                col: 2
            },
            '4': {
                answer: 'ஓருள்ளம்',
                row: 0,
                col: 4
            }
        }
      },
// 61
{
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'உணவும் வகையும்',
    across: {
        '1': {
            answer: 'சாம்பார்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'பழம்',
            row: 3,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'சாப்பாடு',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'பாலப்பம்',
            row: 0,
            col: 2
        },
        '4': {
            answer: 'குழம்பு',
            row: 1,
            col: 4
        }
    }
  },
// 62
{
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'உணவும் சுவையும்',
    across: {
        '1': {
            answer: 'இனிப்பு',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'உவர்ப்பு',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'புட்டு',
            row: 4,
            col: 0
        },
        '5': {
            answer: 'புளி',
            row: 3,
            col: 3
        }
    },
    down: {
        '2': {
            answer: 'உப்பு',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'புளிப்பு',
            row: 0,
            col: 3
        },
        '6': {
            answer: 'புளிமா',
            row: 2,
            col: 4
        }
    }
  },
// 63
{
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'தமிழர் விளையாட்டுகள்',
    across: {
        '1': {
            answer: 'சிலம்பம்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'கபடி',
            row: 2,
            col: 2
        },
        '4': {
            answer: 'தாயம்',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'சிற்றில்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'பம்பரம்',
            row: 0,
            col: 3
        }
    }
  },
// 64
{
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'கணக்கு - கணிதம்',
    across: {
        '1': {
            answer: 'நான்கு',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'குலவு',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'வாய்ப்பாடு',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'நாங்கு',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'குறைவு',
            row: 0,
            col: 2
        },
        '5': {
            answer: 'பதினெட்டு',
            row: 0,
            col: 4
        }
    }
  },
// 65
{
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'மழை',
    across: {
        '1': {
            answer: 'மும்மாரி',
            row: 0,
            col: 1
        },
        '2': {
            answer: 'கல்மழை',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'மழைமுகில்',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'முதல்மழை',
            row: 0,
            col: 1
        },
        '4': {
            answer: 'மாமழை',
            row: 0,
            col: 3
        }
    }
  },
// 66
{
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'குறள் அதிகாரம்',
    across: {
        '2': {
            answer: 'நல்குரவு',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'வாய்மை',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'இகல்',
            row: 0,
            col: 1
        },
        '3': {
            answer: 'குடிமை',
            row: 2,
            col: 2
        },
        '5': {
            answer: 'அறிவுடைமை',
            row: 0,
            col: 4
        }
    }
  },
// 67
{
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'கல்வி - படிப்பு',
    across: {
        '1': {
            answer: 'பாடநூல்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'சான்றிதழ்',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'மேல்நிலை',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'பாடசாலை',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'நூலறிதல்',
            row: 0,
            col: 2
        },
        '5': {
            answer: 'கீழ்நிலை',
            row: 1,
            col: 4
        }
    }
  },
// 68
{
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'மலர்கள்',
    across: {
        '1': {
            answer: 'வாடாமல்லி',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'அனிச்சம்',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'கைதை',
            row: 4,
            col: 2
        }
    },
    down: {
        '2': {
            answer: 'அல்லி',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'மணிச்சிகை',
            row: 0,
            col: 2
        }
    }
  },
  // 69
{
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    across: {
        '1': {
            answer: 'பாதுகாப்பு',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'புல்பூண்டு',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'பாவைநோன்பு',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'காகிதப்பூ',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'புத்தாண்டு',
            row: 0,
            col: 4
        }
    }
  },
// 70
    {
        author: 'முகிலன் முருகன்',
        theme: 'முனைப்பு - எத்தனிப்பு',
        across: {
            '2': {
                answer: 'வலிமை',
                row: 0,
                col: 2
            },
            '3': {
                answer: 'உறுதி',
                row: 2,
                col: 2
            },
            '5': {
                answer: 'ஊக்கம்',
                row: 4,
                col: 1
            }
        },
        down: {
            '1': {
                answer: 'முயற்சி',
                row: 0,
                col: 0
            },
            '4': {
                answer: 'திடம்',
                row: 2,
                col: 4
            }
        }
      },
// 71
    {
        author: 'முகிலன் முருகன்',
        theme: 'காசு',
        across: {
            '1': {
                answer: 'பொருள்',
                row: 0,
                col: 0
            },
            '4': {
                answer: 'நாணயம்',
                row: 3,
                col: 1
            }
        },
        down: {
            '1': {
                answer: 'பொன்',
                row: 0,
                col: 0
            },
            '2': {
                answer: 'செல்வம்',
                row: 0,
                col: 4
            },
            '3': {
                answer: 'பணம்',
                row: 2,
                col: 2
            }
        }
      },
// 72
{
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'மக்களாட்சி',
    across: {
        '1': {
            answer: 'செல்வாக்கு',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'தேர்தல்',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'செப்பாடு',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'வாக்காளர்',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'குடியியல்',
            row: 0,
            col: 4
        }
    }
  },
// 73
{
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'இயற்கை வளங்கள்',
    across: {
        '1': {
            answer: 'மழைக்காடு',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'வற்றாநதி',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'மைஞ்சு',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'மண்வளமை',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'கால்நடை',
            row: 0,
            col: 3
        }
    }
  },
// 74
{
    author: 'முகிலன் முருகன்',
    theme: 'பூமி - தரணி',
    across: {
        '2': {
            answer: 'புவி',
            row: 0,
            col: 1
        },
        '5': {
            answer: 'உலகம்',
            row: 3,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'பார்',
            row: 1,
            col: 0
        },
        '3': {
            answer: 'வையகம்',
            row: 0,
            col: 4
        },
        '4': {
            answer: 'ஞாலம்',
            row: 2,
            col: 2
        }
    }
  },
  // 75
{
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'உறவுமுறை',
    across: {
        '1': {
            answer: 'அம்மா',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'மகன்',
            row: 1,
            col: 2
        },
        '5': {
            answer: 'முறைமாமா',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'அண்ணன்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'மாமன்',
            row: 0,
            col: 2
        },
        '4': {
            answer: 'சின்னம்மா',
            row: 0,
            col: 4
        }
    }
  },
// 76
{
    author: 'முகிலன் முருகன்',
    theme: 'மீன் வகைகள்',
    across: {
        '2': {
            answer: 'கயல்',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'வவ்வால்',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'கரை',
            row: 4,
            col: 3
        }
    },
    down: {
        '1': {
            answer: 'சூடைவலை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'கருவாளை',
            row: 0,
            col: 2
        },
        '4': {
            answer: 'பாரை',
            row: 3,
            col: 4
        }
    }
  },
// 77
  {
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'காட்டு விலங்கு',
    across: {
        '1': {
            answer: 'குரங்கு',
            row: 0,
            col: 1
        },
        '3': {
            answer: 'மரை',
            row: 2,
            col: 3
        },
        '4': {
            answer: 'வரிப்புலி',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'குள்ளநரி',
            row: 0,
            col: 1
        },
        '2': {
            answer: 'குதிரை',
            row: 0,
            col: 4
        }
    }
  },
// 78
{
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'காட்டு விலங்கு',
    across: {
        '1': {
            answer: 'சிங்கம்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'மாநிரை',
            row: 3,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'சிறுத்தை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'கவரிமான்',
            row: 0,
            col: 2
        },
        '4': {
            answer: 'குதிரை',
            row: 1,
            col: 4
        }
    }
  },
// 79
{
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'காய்கறி',
    across: {
        '1': {
            answer: 'கொத்தவரை',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'வெங்காயம்',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'வாழை',
            row: 4,
            col: 3
        }
    },
    down: {
        '2': {
            answer: 'தக்காளி',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'வெண்டை',
            row: 2,
            col: 0
        }
    }
  },
// 80
{
    author: 'முகிலன் முருகன்',
    theme: 'பறவைகள்',
    across: {
        '1': {
            answer: 'காகம்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'கழுகு',
            row: 2,
            col: 2
        },
        '4': {
            answer: 'கோழி',
            row: 3,
            col: 0
        },
        '5': {
            answer: 'மயில்',
            row: 4,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'கானாங்கோழி',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'மாங்குயில்',
            row: 0,
            col: 4
        }
    }
  },
// 81
{
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'நிலா',
    across: {
        '1': {
            answer: 'சந்திரன்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'தண்கதிர்',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'மதி',
            row: 4,
            col: 3
        }
    },
    down: {
        '1': {
            answer: 'சந்தகன்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'திங்கள்',
            row: 0,
            col: 2
        }
    }
  },
  // 82
{
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'நீர்நிலை',
    across: {
        '1': {
            answer: 'நீர்த்தாரை',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'அகழி',
            row: 2,
            col: 2
        },
        '4': {
            answer: 'சுரியல்',
            row: 3,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'நீர்ச்சுனை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'தாங்கல்',
            row: 0,
            col: 3
        },
        '3': {
            answer: 'அயம்',
            row: 2,
            col: 2
        }
    }
  },
 // 83
{
    author: 'முகிலன் முருகன்',
    theme: 'பூக்கள்',
    across: {
        '1': {
            answer: 'ஆம்பல்',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'தேமா',
            row: 4,
            col: 0
        },
        '5': {
            answer: 'வாகை',
            row: 4,
            col: 3
        }
    },
    down: {
        '1': {
            answer: 'ஆவிரை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'பவளம்',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'மல்லிகை',
            row: 1,
            col: 4
        }
    }
  },
  // 84
  {
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'அடுக்குத் தொடர்',
    across: {
        '1': {
            answer: 'ஆண்டாண்டு',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'குலைகுலை',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'ஆங்காங்கு',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'ஏகேகு',
            row: 2,
            col: 2
        },
        '3': {
            answer: 'போபோ',
            row: 2,
            col: 4
        }
    }
  },
// 85
{
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'தமிழர் இசைக்கருவிகள்',
    across: {
        '1': {
            answer: 'மத்தளம்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'குழல்',
            row: 3,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'மண்மேளம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'தமுக்கு',
            row: 0,
            col: 2
        },
        '4': {
            answer: 'வில்',
            row: 2,
            col: 4
        }
    }
  },
  // 86
{
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'கடல்',
    across: {
        '1': {
            answer: 'நெடுநீர்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'நீரகம்',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'அம்புதி',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'நெறிநீர்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'கயம்',
            row: 2,
            col: 2
        }
    }
  },
  // 87
{
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'நட்பு',
    across: {
        '1': {
            answer: 'பேனாநட்பு',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'நல்லார்',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'பேருதவி',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'நட்பியல்',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'புரிந்தோர்',
            row: 0,
            col: 4
        }
    }
  },
   // 88
{
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'வீடு',
    across: {
        '1': {
            answer: 'கூரைதாங்கி',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'வீடுவாசல்',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'நும்மனை',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'கூரைவீடு',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'தாழ்வாரம்',
            row: 0,
            col: 2
        }
    }
  },
  // 89
{
    author: 'முகிலன் முருகன்',
    theme: 'சூரியன்',
    across: {
        '1': {
            answer: 'பகலோன்',
            row: 0,
            col: 1
        },
        '2': {
            answer: 'கதிரவன்',
            row: 2,
            col: 0
        },
        '3': {
            answer: 'ஞாயிறு',
            row: 4,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'பரிதி',
            row: 0,
            col: 1
        },
        '2': {
            answer: 'கனலி',
            row: 2,
            col: 0
        }
    }
  },
  // 90
  {
    author: 'முகிலன் முருகன்',
    theme: 'பூச்சிகள்',
    across: {
        '1': {
            answer: 'அந்து',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'தட்டான்',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'அறுகால்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'தும்பி',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'சீலைப்பேன்',
            row: 0,
            col: 4
        }
    }
  },
   // 91
   {
    author: 'முகிலன் முருகன்',
    theme: 'மரங்கள்',
    across: {
        '1': {
            answer: 'ஆசினி',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'எகடம்',
            row: 1,
            col: 0
        },
        '4': {
            answer: 'தில்லை',
            row: 2,
            col: 0
        },
        '6': {
            answer: 'படுபனை',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'ஆடலை',
            row: 0,
            col: 2
        },
        '2': {
            answer: 'சிம்',
            row: 0,
            col: 3
        },
        '3': {
            answer: 'எதிளை',
            row: 1,
            col: 0
        },
        '4': {
            answer: 'கல்',
            row: 1,
            col: 1
        },
        '5': {
            answer: 'தென்னை',
            row: 2,
            col: 4
        }
    }
  },
  // 92
  {
    author: 'முகிலன் முருகன்',
    theme: 'உணவுகள்',
    across: {
        '1': {
            answer: 'அப்பளம்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'சட்டினி',
            row: 3,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'அதிரசம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'பச்சடி',
            row: 0,
            col: 2
        }
    }
  },
  // 93
  {
    author: 'முகிலன் முருகன்',
    theme: 'பழங்கள்',
    across: {
        '2': {
            answer: 'நெல்லி',
            row: 1,
            col: 0
        },
        '3': {
            answer: 'மாம்பழம்',
            row: 3,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'வில்வம்',
            row: 0,
            col: 1
        },
        '4': {
            answer: 'பலா',
            row: 3,
            col: 2
        },
        '5': {
            answer: 'மாதுளம்',
            row: 0,
            col: 4
        }
    }
  },
   // 94
   {
    author: 'முகிலன் முருகன்',
    theme: 'எண்கள்',
    across: {
        '1': {
            answer: 'ஏழு',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'ஒன்று',
            row: 1,
            col: 2
        },
        '4': {
            answer: 'பத்து',
            row: 3,
            col: 2
        },
        '5': {
            answer: 'ஐந்து',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'ஏழேழு',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'ஒன்பது',
            row: 1,
            col: 2
        },
        '3': {
            answer: 'ஆறு',
            row: 0,
            col: 4
        }
    }
  },
// 95
{
    author: 'முகிலன் முருகன்',
    theme: 'சங்ககால மலர்கள்',
    across: {
        '1': {
            answer: 'பாலை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'ஆத்தி',
            row: 1,
            col: 2
        },
        '4': {
            answer: 'பசலை',
            row: 3,
            col: 2
        },
        '5': {
            answer: 'மௌவல்',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'பாதிரி',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'ஆம்பல்',
            row: 1,
            col: 2
        },
        '3': {
            answer: 'தில்லை',
            row: 1,
            col: 4
        }
    }
  },
  // 96
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'ஐந்நிலம்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'திருமணம்',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'கையுறை',
            row: 4,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'ஐந்திரம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'நிலமங்கை',
            row: 0,
            col: 2
        }
    }
  },
// 97
{
    author: 'முகிலன் முருகன்',
    theme: 'உடல் உறுப்பு',
    across: {
        '1': {
            answer: 'கால்',
            row: 0,
            col: 3
        },
        '2': {
            answer: 'கழுத்து',
            row: 1,
            col: 0
        },
        '4': {
            answer: 'மூக்கு',
            row: 4,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'காது',
            row: 0,
            col: 3
        },
        '2': {
            answer: 'கன்னம்',
            row: 1,
            col: 0
        },
        '3': {
            answer: 'நாக்கு',
            row: 2,
            col: 4
        }
    }
  },
  // 98
{
    author: 'முகிலன் முருகன்',
    theme: 'காதல்',
    across: {
        '1': {
            answer: 'நயப்பு',
            row: 0,
            col: 1
        },
        '2': {
            answer: 'ஆசை',
            row: 1,
            col: 0
        },
        '4': {
            answer: 'மோகம்',
            row: 4,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'நசை',
            row: 0,
            col: 1
        },
        '2': {
            answer: 'ஆதரம்',
            row: 1,
            col: 0
        },
        '3': {
            answer: 'காமம்',
            row: 2,
            col: 4
        }
    }
  },
   // 99
{
    author: 'முகிலன் முருகன்',
    theme: 'பொழுதுகள்',
    across: {
        '1': {
            answer: 'யாமம்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'காலை',
            row: 1,
            col: 3
        },
        '4': {
            answer: 'கூதிர்',
            row: 2,
            col: 1
        },
        '5': {
            answer: 'நண்பகல்',
            row: 4,
            col: 0
        }
    },
    down: {
        '2': {
            answer: 'மாலை',
            row: 0,
            col: 4
        },
        '3': {
            answer: 'கார்',
            row: 1,
            col: 3
        }
    }
  },
   // 100
{
    author: 'முகிலன் முருகன்',
    theme: 'இரட்டைக்கிளவி',
    across: {
        '1': {
            answer: 'கல',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'விறு',
            row: 0,
            col: 3
        },
        '3': {
            answer: 'கிறு',
            row: 1,
            col: 2
        },
        '4': {
            answer: 'நறு',
            row: 2,
            col: 1
        },
        '5': {
            answer: 'குறு',
            row: 3,
            col: 0
        },
        '7': {
            answer: 'கட',
            row: 3,
            col: 3
        },
        '8': {
            answer: 'கடு',
            row: 4,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'கல',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'விறு',
            row: 0,
            col: 3
        },
        '3': {
            answer: 'கிறு',
            row: 1,
            col: 2
        },
        '4': {
            answer: 'நறு',
            row: 2,
            col: 1
        },
        '5': {
            answer: 'குறு',
            row: 3,
            col: 0
        },
        '6': {
            answer: 'கட',
            row: 2,
            col: 4
        },
        '7': {
            answer: 'கடு',
            row: 3,
            col: 3
        }
    }
  },
  // 101
{
    author: 'முகிலன் முருகன்',
    theme: 'இரட்டைக்கிளவி',
    across: {
        '1': {
            answer: 'தக',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'கடு',
            row: 1,
            col: 0
        },
        '3': {
            answer: 'கம',
            row: 0,
            col: 3
        },
        '4': {
            answer: 'மள',
            row: 1,
            col: 3
        },
        '5': {
            answer: 'குபு',
            row: 3,
            col: 0
        },
        '6': {
            answer: 'புறு',
            row: 4,
            col: 0
        },
        '7': {
            answer: 'மெது',
            row: 3,
            col: 3
        },
        '8': {
            answer: 'துரு',
            row: 4,
            col: 3
        }
    },
    down: {
        '1': {
            answer: 'தக',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'கடு',
            row: 0,
            col: 1
        },
        '3': {
            answer: 'கம',
            row: 0,
            col: 3
        },
        '4': {
            answer: 'மள',
            row: 0,
            col: 4
        },
        '5': {
            answer: 'குபு',
            row: 3,
            col: 0
        },
        '6': {
            answer: 'புறு',
            row: 3,
            col: 1
        },
        '7': {
            answer: 'மெது',
            row: 3,
            col: 3
        },
        '8': {
            answer: 'துரு',
            row: 3,
            col: 4
        }
    }
  },
   // 102
{
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'ஊர்திகள்',
    across: {
        '1': {
            answer: 'நாவாய்',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'மிதியுந்து',
            row: 3,
            col: 0
        }
    },
    down: {
        '2': {
            answer: 'வானூர்தி',
            row: 0,
            col: 1
        },
        '3': {
            answer: 'பேருந்து',
            row: 1,
            col: 3
        },
        '4': {
            answer: 'மின்',
            row: 3,
            col: 0
        }
    }
  },
   // 103
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'ஏவுகணை',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'காதணி',
            row: 2,
            col: 2
        },
        '5': {
            answer: 'மகரம்',
            row: 3,
            col: 0
        },
        '7': {
            answer: 'திடம்',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'ஏற்றுமதி',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'கடிகாரம்',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'பணி',
            row: 1,
            col: 4
        },
        '4': {
            answer: 'தம்',
            row: 2,
            col: 3
        },
        '6': {
            answer: 'கட',
            row: 3,
            col: 1
        }
    }
  },
   // 104
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'தங்கம்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'துணிச்சல்',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'காகம்',
            row: 4,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'தத்துவம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'இல்லம்',
            row: 1,
            col: 4
        }
    }
  },
   // 105
{
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'யானை',
    across: {
        '1': {
            answer: 'நால்வாய்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'கயம்',
            row: 3,
            col: 0
        },
        '5': {
            answer: 'பிடி',
            row: 4,
            col: 3
        }
    },
    down: {
        '2': {
            answer: 'வாரணம்',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'கரி',
            row: 3,
            col: 0
        },
        '4': {
            answer: 'பொங்கடி',
            row: 1,
            col: 4
        }
    }
  },
   // 106
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'உழுந்து',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'துடப்பம்',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'உணவு',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'உறுதுணை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'துப்பறிவு',
            row: 0,
            col: 3
        }
    }
  },
  // 107
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'அரசியல்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'வாணிகம்',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'ஐம்படை',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'அரிவாள்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'சிக்கனம்',
            row: 0,
            col: 2
        },
        '4': {
            answer: 'கூடை',
            row: 3,
            col: 4
        }
    }
  },
  // 108 - 01/07/2022
{
    author: 'முகிலன் முருகன்',
    theme: 'தானியம் - கூலம்',
    across: {
        '1': {
            answer: 'உளுந்து',
            row: 0,
            col: 1
        },
        '4': {
            answer: 'அவரை',
            row: 2,
            col: 2
        },
        '6': {
            answer: 'இறுங்கு',
            row: 4,
            col: 0
        }
    },
    down: {
        '2': {
            answer: 'துவரை',
            row: 0,
            col: 4
        },
        '3': {
            answer: 'திணை',
            row: 1,
            col: 0
        },
        '5': {
            answer: 'வரகு',
            row: 2,
            col: 3
        }
    }
  },
  // 109 - 02/07/2022
{
    author: 'முகிலன் முருகன்',
    theme: 'கீழ்வாய் எண்கள்',
    across: {
        '2': {
            answer: 'மா',
            row: 0,
            col: 4
        },
        '3': {
            answer: 'முந்திரி',
            row: 1,
            col: 0
        },
        '4': {
            answer: 'மும்மி',
            row: 3,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'கதிர்முனை',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'முக்கால்',
            row: 1,
            col: 0
        }
    }
  },
   // 110 - 03/07/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'ஆலமரம்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'வணக்கம்',
            row: 2,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'ஆய்வகம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'மரக்கறி',
            row: 0,
            col: 2
        }
    }
  },
    // 111 - 04/07/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'இளநீர்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'வடபகுதி',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'குமரி',
            row: 4,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'இலவசம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'அதிகாரி',
            row: 1,
            col: 4
        },
        '4': {
            answer: 'படகு',
            row: 2,
            col: 2
        }
    }
  },
   // 112 - 05/07/2022
{
    author: 'முகிலன் முருகன்',
    theme: 'குறள் சொல்',
    across: {
        '1': {
            answer: 'கற்க',
            row: 1,
            col: 0
        },
        '3': {
            answer: 'ஓதி',
            row: 0,
            col: 3
        },
        '6': {
            answer: 'அருள்',
            row: 3,
            col: 2
        },
        '8': {
            answer: 'தினை',
            row: 4,
            col: 0
        }
    },
    down: {
        '2': {
            answer: 'நிற்க',
            row: 0,
            col: 1
        },
        '4': {
            answer: 'திணை',
            row: 0,
            col: 4
        },
        '5': {
            answer: 'பொருள்',
            row: 2,
            col: 3
        },
        '7': {
            answer: 'ஆதி',
            row: 3,
            col: 0
        }
    }
  },
  // 113 - 06/07/2022
{
    author: 'முகிலன் முருகன்',
    theme: 'குறள் சொல்',
    across: {
        '1': {
            answer: 'மதி',
            row: 0,
            col: 1
        },
        '2': {
            answer: 'குடி',
            row: 1,
            col: 0
        },
        '4': {
            answer: 'சிறை',
            row: 1,
            col: 3
        },
        '5': {
            answer: 'மறு',
            row: 2,
            col: 2
        },
        '6': {
            answer: 'பனை',
            row: 3,
            col: 1
        },
        '7': {
            answer: 'மறை',
            row: 4,
            col: 0
        },
        '9': {
            answer: 'கேடு',
            row: 4,
            col: 3
        }
    },
    down: {
        '1': {
            answer: 'மடி',
            row: 0,
            col: 1
        },
        '2': {
            answer: 'குடை',
            row: 1,
            col: 0
        },
        '3': {
            answer: 'இறை',
            row: 0,
            col: 4
        },
        '4': {
            answer: 'சிறு',
            row: 1,
            col: 3
        },
        '5': {
            answer: 'மனை',
            row: 2,
            col: 2
        },
        '6': {
            answer: 'பறை',
            row: 3,
            col: 1
        },
        '8': {
            answer: 'கெடு',
            row: 3,
            col: 4
        }
    }
  },
  // 114 - 07/07/2022
{
    author: 'முகிலன் முருகன்',
    theme: 'குறள் சொல்',
    across: {
        '1': {
            answer: 'கொக்கு',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'கையாறு',
            row: 2,
            col: 0
        },
        '6': {
            answer: 'காண்',
            row: 3,
            col: 3
        },
        '5': {
            answer: 'புகழ்மை',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'கொள்கை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'குன்று',
            row: 0,
            col: 2
        },
        '4': {
            answer: 'யாப்பு',
            row: 2,
            col: 1
        },
        '6': {
            answer: 'காழ்',
            row: 3,
            col: 3
        },
        '7': {
            answer: 'சான்றாண்மை',
            row: 0,
            col: 4
        }
    }
  },
// 115 - 08/07/2022
   {
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'உருவம்',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'கங்கனம்',
            row: 3,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'உணவகம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'வஞ்சகம்',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'குறும்பு',
            row: 1,
            col: 4
        }
    }
  },
   // 116 - 09/07/2022
{
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'பண்புப்பெயர்',
    across: {
        '1': {
            answer: 'பைந்தமிழ்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'கூர்கத்தி',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'சீர்நிலை',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'பைங்கூழ்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'தண்கதிர்',
            row: 0,
            col: 2
        }
    }
  },
   // 117 - 10/07/2022
{
    author: 'முகிலன் முருகன்',
    theme: 'அற நூல்கள்',
    across: {
        '2': {
            answer: 'ஆத்திசூடி',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'மூதுரை',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'ஏலாதி',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'நாலடியார்',
            row: 0,
            col: 4
        }
    }
  },
   // 118 - 11/07/2022
{
    author: 'முகிலன் முருகன்',
    theme: 'எதிர்ச்சொல்',
    across: {
        '2': {
            answer: 'மேதை',
            row: 1,
            col: 0
        },
        '4': {
            answer: 'முடி',
            row: 1,
            col: 3
        },
        '5': {
            answer: 'பின்',
            row: 2,
            col: 2
        },
        '7': {
            answer: 'குறை',
            row: 4,
            col: 0
        },
        '9': {
            answer: 'பீடு',
            row: 4,
            col: 3
        }
    },
    down: {
        '1': {
            answer: 'பேதை',
            row: 0,
            col: 1
        },
        '3': {
            answer: 'அடி',
            row: 0,
            col: 4
        },
        '4': {
            answer: 'முன்',
            row: 1,
            col: 3
        },
        '6': {
            answer: 'நிறை',
            row: 3,
            col: 1
        },
        '8': {
            answer: 'கேடு',
            row: 3,
            col: 4
        }
    }
  },
  // 119 - 12/07/2022
{
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'வெளிச்சம்',
    across: {
        '1': {
            answer: 'நண்பகல்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'நிலவு',
            row: 2,
            col: 1
        },
        '4': {
            answer: 'மின்னல்',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'நள்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'பகலவன்',
            row: 0,
            col: 2
        },
        '5': {
            answer: 'அல்',
            row: 3,
            col: 4
        }
    }
  },
  // 120 - 13/07/2022
{
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'நிறங்கள்',
    across: {
        '1': {
            answer: 'சருகிலை',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'பாணிச்சாய்',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'உறைபால்',
            row: 4,
            col: 1
        }
    },
    down: {
        '2': {
            answer: 'கிளிச்சிறை',
            row: 0,
            col: 2
        }
    }
  },
 // 121 - 14/07/2022
 {
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'ஊர்வலம்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'முடியாட்சி',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'கொதிப்பி',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'ஊசிமுனை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'வளையாபதி',
            row: 0,
            col: 2
        },
        '4': {
            answer: 'சிற்பி',
            row: 2,
            col: 4
        }
    }
  },
  // 122 - 15/07/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'அச்சகம்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'கங்கணம்',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'விழும்பம்',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'அறிகருவி',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'சங்கமம்',
            row: 0,
            col: 2
        }
    }
  },
  // 123 - 16/07/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'அரசாட்சி',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'முற்றிலும்',
            row: 2,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'அறிமுகம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'சான்றிதழ்',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'சிலம்பம்',
            row: 0,
            col: 4
        }
    }
  },
  // 124 - 17/07/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'ஆழ்கடல்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'மயிற்சிகை',
            row: 2,
            col: 0
        },
        '6': {
            answer: 'கல்வி',
            row: 3,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'ஆழ்மனம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'கடற்கரை',
            row: 0,
            col: 2
        },
        '4': {
            answer: 'சில்',
            row: 2,
            col: 3
        },
        '5': {
            answer: 'கைவிசை',
            row: 2,
            col: 4
        }
    }
  },
   // 125 - 18/07/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'இடதுசெவி',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'கம்பளம்',
            row: 3,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'இடைமுகம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'துடைப்பம்',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'கம்பி',
            row: 2,
            col: 4
        }
    }
  },
   // 126 - 19/07/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'ஈட்டிமுனை',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'பாதுகாப்பு',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'பொனை',
            row: 3,
            col: 3
        },
        '6': {
            answer: 'மீளாய்வு',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'ஈடுபாடு',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'முழுப்பொய்',
            row: 0,
            col: 3
        },
        '4': {
            answer: 'புனைவு',
            row: 2,
            col: 4
        }
    }
  },
  // 127 - 20/07/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'உட்பகுதி',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'மூக்குத்தி',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'குணம்',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'உள்மூக்கு',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'பக்குவம்',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'தித்திப்பு',
            row: 0,
            col: 4
        }
    }
  },
   // 128 - 21/07/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'ஊர்வம்பு',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'கற்சிலை',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'பிரம்படி',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'ஊதுகம்பி',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'வஞ்சிரம்',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'புகை',
            row: 0,
            col: 4
        },
        '6': {
            answer: 'மடி',
            row: 3,
            col: 4
        }
    }
  },
  // 129 - 22/07/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'எண்வரிசை',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'பொற்காலம்',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'புகழ்',
            row: 4,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'எரிபொருள்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'வளைகாப்பு',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'சைவம்',
            row: 0,
            col: 4
        }
    }
  },
  // 130 - 23/07/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'ஏழ்பிறவி',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'முச்சந்தி',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'சதுரம்',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'ஏழுமுறை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'பின்சந்து',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'விந்தியம்',
            row: 0,
            col: 4
        }
    }
  },
  // 131 - 24/07/2022
{
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'சிறுதானியம்',
    across: {
        '1': {
            answer: 'கேழ்வரகு',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'கம்பு',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'கேப்பை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'வரகு',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'குதிரைவாலி',
            row: 0,
            col: 4
        }
    }
  },
  // 132 - 25/07/2022
{
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: ' நில வகை',
    across: {
        '1': {
            answer: 'தினைபுனம்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'நன்செய்',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'மனை',
            row: 4,
            col: 0
        },
        '6': {
            answer: 'சோலை',
            row: 4,
            col: 3
        }
    },
    down: {
        '2': {
            answer: 'புன்செய்',
            row: 0,
            col: 2
        },
        '5': {
            answer: 'பாலை',
            row: 3,
            col: 4
        }
    }
  },
   // 133 - 26/07/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'ஒளிவாங்கி',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'திருமணம்',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'வலிமை',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'ஒத்திகை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'வாடாமல்லி',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'கிராம்பு',
            row: 0,
            col: 4
        }
    }
  },
     // 134 - 27/07/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'ஓடுபாதை',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'வாயிற்படி',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'ஆய்தம்',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'ஓதுவார்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'பாகற்காய்',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'கடினம்',
            row: 1,
            col: 4
        }
    }
  },
 // 135 - 28/07/2022
 {
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'ழ் சொற்கள்',
    across: {
        '1': {
            answer: 'ஆழ்கிணறு',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'மாழ்கு',
            row: 2,
            col: 2
        },
        '4': {
            answer: 'பல்லிதழ்',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'ஆகூழ்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'குமிழ்',
            row: 2,
            col: 4
        }
    }
  },
 // 136 - 29/07/2022
 {
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'ழ் சொற்கள்',
    across: {
        '1': {
            answer: 'மகிழ்ச்சி',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'இமிழ்',
            row: 2,
            col: 2
        },
        '4': {
            answer: 'தெறுழ்',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'மகிழ்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'சிமிழ்',
            row: 0,
            col: 4
        },
        '3': {
            answer: 'இயாழ்',
            row: 2,
            col: 2
        }
    }
  },
  // 137 - 30/07/2022
 {
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'மகிழ்ச்சி',
    across: {
        '1': {
            answer: 'ஆனந்தம்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'புளகு',
            row: 3,
            col: 0
        },
        '5': {
            answer: 'ஓகை',
            row: 4,
            col: 3
        }
    },
    down: {
        '1': {
            answer: 'ஆர்ப்பு',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'தனகு',
            row: 0,
            col: 3
        },
        '4': {
            answer: 'நகை',
            row: 3,
            col: 4
        }
    }
  },
     // 138 - 31/07/2022
     {
        author: 'முகிலன் முருகன்',
        across: {
            '1': {
                answer: 'கடிகாரம்',
                row: 0,
                col: 0
            },
            '3': {
                answer: 'வடபகுதி',
                row: 2,
                col: 0
            },
            '5': {
                answer: 'சதுரம்',
                row: 4,
                col: 1
            }
        },
        down: {
            '1': {
                answer: 'கருவறை',
                row: 0,
                col: 0
            },
            '2': {
                answer: 'காற்பந்து',
                row: 0,
                col: 2
            },
            '4': {
                answer: 'திறம்',
                row: 2,
                col: 4
            }
        }
      },
 // 139 - 01/08/2022
        {
            author: 'முகிலன் முருகன்',
            across: {
                '1': {
                    answer: 'கால்நடை',
                    row: 0,
                    col: 0
                },
                '3': {
                    answer: 'பழச்சாறு',
                    row: 2,
                    col: 0
                },
                '5': {
                    answer: 'வைப்பு',
                    row: 4,
                    col: 2
                }
            },
            down: {
                '1': {
                    answer: 'காற்பந்து',
                    row: 0,
                    col: 0
                },
                '2': {
                    answer: 'நகைச்சுவை',
                    row: 0,
                    col: 2
                },
                '4': {
                    answer: 'உறுப்பு',
                    row: 1,
                    col: 4
                }
            }
          },
// 140 - 02/08/2022
        {
            author: 'முகிலன் முருகன்',
            across: {
                '1': {
                    answer: 'கிராம்பு',
                    row: 0,
                    col: 0
                },
                '3': {
                    answer: 'வெறி',
                    row: 2,
                    col: 3
                },
                '4': {
                    answer: 'தக்காளி',
                    row: 3,
                    col: 0
                }
            },
            down: {
                '1': {
                    answer: 'கிரந்தம்',
                    row: 0,
                    col: 0
                },
                '2': {
                    answer: 'புறவெளி',
                    row: 0,
                    col: 3
                },
                '5': {
                    answer: 'கால்',
                    row: 3,
                    col: 2
                }
            }
          },
// 141 - 03/08/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'கீழ்பகுதி',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'வழுக்கை',
            row: 2,
            col: 0
        },
        '6': {
            answer: 'கதிர்',
            row: 3,
            col: 2
        },
        '7': {
            answer: 'சைவம்',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'கீழ்வரிசை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'பதக்கம்',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'தினை',
            row: 0,
            col: 4
        },
        '5': {
            answer: 'கைதி',
            row: 2,
            col: 3
        }
    }
  },
// 142 - 04/08/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'குறிக்கோள்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'குடிமகன்',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'தன்',
            row: 3,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'குங்குமம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'கோமகன்',
            row: 0,
            col: 3
        },
        '4': {
            answer: 'மதகு',
            row: 2,
            col: 2
        }
    }
  },
// 143 - 05/08/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'கூர்கத்தி',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'வளர்பிறை',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'முன்',
            row: 3,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'கூழ்வரகு',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'கதிர்முனை',
            row: 0,
            col: 2
        },
        '4': {
            answer: 'பின்',
            row: 2,
            col: 3
        }
    }
  },
// 144 - 06/08/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'கெடுபிடி',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'பதவி',
            row: 2,
            col: 2
        },
        '6': {
            answer: 'வடகடல்',
            row: 3,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'கெட்டவன்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'பிற்பகல்',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'தவில்',
            row: 1,
            col: 4
        },
        '5': {
            answer: 'தட',
            row: 2,
            col: 3
        }
    }
  },
// 145 - 07/08/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'கைத்தொழில்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'பிடிவாதம்',
            row: 2,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'கைப்பிள்ளை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'தொடுவானம்',
            row: 0,
            col: 2
        }
    }
  },
// 146 - 08/08/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'கொள்கலன்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'நிலத்தடி',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'அரும்பு',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'கொதிநிலை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'கடைத்தெரு',
            row: 0,
            col: 2
        }
    }
  },
// 147 - 09/08/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'கோட்பாடு',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'துப்பறிவு',
            row: 2,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'கோத்தும்பி',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'பால்பண்ணை',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'ஏவுகணை',
            row: 1,
            col: 4
        }
    }
  },
// 148 - 10/08/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'சதுக்கம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'நிகழ்ச்சி',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'சடங்கு',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'சமநிலை',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'சிறகு',
            row: 2,
            col: 4
        }
    }
  },
// 149 - 11/08/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'சாத்திரம்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'பாடத்துறை',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'கும்பம்',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'சாப்பாடு',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'திருத்தம்',
            row: 0,
            col: 2
        }
    }
  },
  // 150 - 12/08/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'சிலம்பம்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'திருப்பம்',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'அம்மி',
            row: 4,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'சித்திரம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'பம்பரம்',
            row: 0,
            col: 3
        }
    }
  },
 // 151 - 13/08/2022
 {
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'சீரமைப்பு',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'நிலவேம்பு',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'ஆம்பல்',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'சீர்நிலை',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'வேடம்',
            row: 2,
            col: 2
        },
        '4': {
            answer: 'புயல்',
            row: 2,
            col: 4
        }
    }
  },
// 152 - 14/08/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'சுயம்பு',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'காப்பகம்',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'இடைவெளி',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'சுடுகாடு',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'பட்டை',
            row: 2,
            col: 2
        },
        '4': {
            answer: 'கம்பளி',
            row: 1,
            col: 4
        }
    }
  },
// 153 - 15/08/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'சூழ்நிலை',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'திகழ்ச்சி',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'சின்னை',
            row: 4,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'சூத்திரம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'நிகழ்ச்சி',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'ஊசிமுனை',
            row: 1,
            col: 4
        }
    }
  },
// 154 - 16/08/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'செடிகொடி',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'மகிழ்',
            row: 2,
            col: 2
        },
        '5': {
            answer: 'ஐம்முனை',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'செம்மொழி',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'கொடிமரம்',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'ஊழ்வினை',
            row: 1,
            col: 4
        }
    }
  },
// 155 - 17/08/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'சேமிப்பு',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'நலிவு',
            row: 2,
            col: 2
        },
        '4': {
            answer: 'புதினம்',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'சேகரிப்பு',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'புகலிடம்',
            row: 0,
            col: 3
        }
    }
  },
// 156 - 18/08/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'சொல்லாடல்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'புத்தகம்',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'திறன்',
            row: 4,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'சொற்புதிர்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'தகுதி',
            row: 2,
            col: 2
        }
    }
  },
// 157 - 19/08/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'சோளக்காடு',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'புதுமுகம்',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'தம்',
            row: 3,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'சோழபுரம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'காலகம்',
            row: 0,
            col: 3
        },
        '4': {
            answer: 'முதல்',
            row: 2,
            col: 2
        }
    }
  },
  // 158 - 20/08/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'தடுப்பூசி',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'முக்கோணம்',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'கும்பம்',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'தலைமுறை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'சிலம்பம்',
            row: 0,
            col: 4
        },
        '4': {
            answer: 'கோலம்',
            row: 2,
            col: 2
        }
    }
  },
  // 159 - 21/08/2022
  {
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'தாமரைப்பூ',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'பணம்',
            row: 2,
            col: 2
        },
        '4': {
            answer: 'இல்லம்',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'தாலாட்டு',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'பூகம்பம்',
            row: 0,
            col: 4
        },
        '3': {
            answer: 'பகல்',
            row: 2,
            col: 2
        }
    }
  },
   // 160 - 22/08/2022
   {
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'திக்குவாய்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'விடுமுறை',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'கம்பளி',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'திருவிழா',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'முகம்',
            row: 2,
            col: 2
        },
        '5': {
            answer: 'ஒளி',
            row: 3,
            col: 4
        }
    }
  },
 // 161 - 23/08/2022
 {
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'தீண்டாமை',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'பொதுநலம்',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'அறுபது',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'தீப்பொறி',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'நன்று',
            row: 2,
            col: 2
        },
        '2': {
            answer: 'ஐம்பது',
            row: 1,
            col: 4
        }
    }
  },
// 162 - 24/08/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'துணிச்சல்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'புண்ணியம்',
            row: 2,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'துப்புரவு',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'சமயம்',
            row: 0,
            col: 3
        }
    }
  },
// 163 - 25/08/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'தூக்கம்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'கபடம்',
            row: 3,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'தூதரகம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'கட்டடம்',
            row: 0,
            col: 2
        }
    }
  },
// 164 - 26/08/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'தென்புலம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'மேம்பாலம்',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'குறைபாடு',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'தென்மேற்கு',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'பாப்பா',
            row: 2,
            col: 2
        }
    }
  },
// 165 - 27/08/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'தேன்சிட்டு',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'பின்புலம்',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'கம்பளி',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'தேய்பிறை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'சிறுபுறம்',
            row: 0,
            col: 2
        }
    }
  },
// 166 - 28/08/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'பட்டியல்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'பதவி',
            row: 2,
            col: 2
        },
        '5': {
            answer: 'பெட்டகம்',
            row: 3,
            col: 0
        },
        '6': {
            answer: 'குடுமி',
            row: 4,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'பணிப்பெண்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'படகு',
            row: 2,
            col: 2
        },
        '3': {
            answer: 'தகடு',
            row: 2,
            col: 3
        },
        '4': {
            answer: 'விம்மி',
            row: 2,
            col: 4
        }
    }
  },
  // 167 - 29/08/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'பாடகர்',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'மரகதம்',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'ஆடை',
            row: 4,
            col: 3
        }
    },
    down: {
        '1': {
            answer: 'பாய்மரம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'கழகம்',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'ஐம்படை',
            row: 1,
            col: 4
        }
    }
  },
   // 168 - 30/08/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'பிடிவாதம்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'விடுகதை',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'புதல்வி',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'பிரிவினை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'வாழ்க',
            row: 0,
            col: 2
        },
        '4': {
            answer: 'தையல்',
            row: 2,
            col: 3
        }
    }
  },
// 169 - 31/08/2022
  {
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'பீப்பாய்',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'கைவலையல்',
            row: 2,
            col: 0
        },
        '6': {
            answer: 'கடுக்காய்',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'பீடிகை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'பாமாலை',
            row: 0,
            col: 2
        },
        '5': {
            answer: 'வண்டு',
            row: 2,
            col: 1
        },
        '3': {
            answer: 'கல்நெய்',
            row: 1,
            col: 4
        }
    }
  },
  // 170 - 01/09/2022
  {
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'புத்தகம்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'நகம்',
            row: 2,
            col: 2
        },
        '5': {
            answer: 'கரு',
            row: 3,
            col: 2
        },
        '6': {
            answer: 'ஊர்தி',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'புதினம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'தலைநகர்',
            row: 0,
            col: 2
        },
        '4': {
            answer: 'கருதி',
            row: 2,
            col: 3
        }
    }
  },
  // 171 - 02/09/2022
  {
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'பூகம்பம்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'தகப்பன்',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'அம்மா',
            row: 4,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'பூந்தளிர்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'பம்பரம்',
            row: 0,
            col: 3
        }
    }
  },
  // 172 - 03/09/2022
  {
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'பெயர்த்தி',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'கையொப்பம்',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'பெருந்தகை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'திருமணம்',
            row: 0,
            col: 4
        }
    }
  },
    // 173 - 04/09/2022
    {
        author: 'முகிலன் முருகன்',
        across: {
            '1': {
                answer: 'பேரங்காடி',
                row: 0,
                col: 0
            },
            '3': {
                answer: 'சக்கரம்',
                row: 3,
                col: 0
            }
        },
        down: {
            '1': {
                answer: 'பேரரசர்',
                row: 0,
                col: 0
            },
            '2': {
                answer: 'காலைநேரம்',
                row: 0,
                col: 3
            }
        }
      },
// 174 - 05/09/2022
       {
        author: 'முகிலன் முருகன்',
        across: {
            '1': {
                answer: 'பைங்கழல்',
                row: 0,
                col: 0
            },
            '3': {
                answer: 'தழற்பூமி',
                row: 2,
                col: 0
            }
        },
        down: {
            '1': {
                answer: 'பைந்தமிழ்',
                row: 0,
                col: 0
            },
            '2': {
                answer: 'கடற்கரை',
                row: 0,
                col: 2
            },
            '4': {
                answer: 'மிளகு',
                row: 2,
                col: 4
            }
        }
      },
// 175 - 06/09/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'பொங்கல்',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'காதணி',
            row: 2,
            col: 2
        },
        '6': {
            answer: 'தகரம்',
            row: 3,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'பொருத்தம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'கடிகாரம்',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'பணி',
            row: 1,
            col: 4
        },
        '5': {
            answer: 'தம்',
            row: 2,
            col: 3
        }
    }
  },
// 176 - 07/09/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'போராட்டம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'வீரக்கலை',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'வம்பு',
            row: 4,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'போர்வீரர்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'களம்',
            row: 2,
            col: 3
        }
    }
  },
// 177 - 08/09/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'நகரம்',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'நிகழ்ச்சி',
            row: 3,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'நடுவுநிலை',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'வாழ்க',
            row: 2,
            col: 2
        },
        '2': {
            answer: 'சிறுசிறு',
            row: 1,
            col: 4
        }
    }
  },
// 178 - 09/09/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'நாடகம்',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'மீள்திறன்',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'இல்லம்',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'நாள்மீன்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'கத்திவால்',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'இன்பம்',
            row: 1,
            col: 4
        }
    }
  },
// 179 - 10/09/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'நிறைமதி',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'வடமேற்கு',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'ஆம்',
            row: 4,
            col: 3
        }
    },
    down: {
        '1': {
            answer: 'நினைவகம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'மண்மேடு',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'மகுடம்',
            row: 1,
            col: 4
        }
    }
  },
// 180 - 11/09/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'நீதிநெறி',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'நிலைப்பேழை',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'ஊர்',
            row: 4,
            col: 3
        }
    },
    down: {
        '1': {
            answer: 'நீர்நிலை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'நெருப்பு',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'மழைநீர்',
            row: 1,
            col: 4
        }
    }
  },
// 181 - 12/09/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'நுழைவாசல்',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'கட்டிடம்',
            row: 3,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'நுணுக்கம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'வாழையடி',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'அம்மி',
            row: 2,
            col: 4
        }
    }
  },
// 182 - 13/09/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'நூலகம்',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'புகைவண்டி',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'தம்',
            row: 4,
            col: 3
        }
    },
    down: {
        '1': {
            answer: 'நூற்புலமை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'கணவன்',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'கடிதம்',
            row: 1,
            col: 4
        }
    }
  },
// 183 - 14/09/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'நெருப்பு',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'கைதி',
            row: 1,
            col: 3
        },
        '4': {
            answer: 'சான்றிதழ்',
            row: 3,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'நெடுஞ்சாலை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'புகைத்தல்',
            row: 0,
            col: 3
        }
    }
  },
// 184 - 15/09/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'நேர்த்தி',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'உவகை',
            row: 2,
            col: 2
        },
        '5': {
            answer: 'கமுக்கம்',
            row: 3,
            col: 0
        },
        '6': {
            answer: 'கும்மை',
            row: 4,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'நேர்முகம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'திரவகம்',
            row: 0,
            col: 3
        },
        '3': {
            answer: 'உக்கு',
            row: 2,
            col: 2
        },
        '4': {
            answer: 'கைம்மை',
            row: 2,
            col: 4
        }
    }
  },
// 185 - 16/09/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'நொதியம்',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'பந்தயம்',
            row: 3,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'நொய்ப்பம்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'பதவி',
            row: 2,
            col: 2
        },
        '2': {
            answer: 'அரும்பு',
            row: 1,
            col: 4
        }
    }
  },
// 186 - 17/09/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'நோக்கம்',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'நொய்ப்பம்',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'இறைவன்',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'நோய்நொடி',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'கழிப்பறை',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'செம்பொன்',
            row: 1,
            col: 4
        }
    }
  },
// 187 - 18/09/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'மகப்பேறு',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'பசுமை',
            row: 2,
            col: 2
        },
        '4': {
            answer: 'சிறுகுழி',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'மகிழ்ச்சி',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'பேச்சுமொழி',
            row: 0,
            col: 3
        }
    }
  },
// 188 - 19/09/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'மாட்சிமை',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'திருப்பம்',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'அரைமணி',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'மாத்திரை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'சிறப்புரை',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'அம்மணி',
            row: 1,
            col: 4
        }
    }
  },
// 189 - 20/09/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'மின்சாரம்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'கயிறு',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'கோடரி',
            row: 3,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'மின்கம்பி',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'சான்றுகோள்',
            row: 0,
            col: 2
        },
        '4': {
            answer: 'அரிசி',
            row: 2,
            col: 4
        }
    }
  },
// 190 - 21/09/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'மீன்கொத்தி',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'வஞ்சகம்',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'கம்பளி',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'மீனவர்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'கொச்சகம்',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'திடம்',
            row: 0,
            col: 4
        }
    }
  },
// 191 - 22/09/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'முக்கோணம்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'துறவி',
            row: 2,
            col: 2
        },
        '5': {
            answer: 'நிறம்',
            row: 3,
            col: 0
        },
        '6': {
            answer: 'பிறகு',
            row: 4,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'முதல்நிலை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'கோத்தும்பி',
            row: 0,
            col: 2
        },
        '4': {
            answer: 'விறகு',
            row: 2,
            col: 4
        }
    }
  },
// 192 - 23/09/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'மூதறிஞர்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'வலிமை',
            row: 2,
            col: 2
        },
        '5': {
            answer: 'வயல்',
            row: 3,
            col: 0
        },
        '6': {
            answer: 'வையம்',
            row: 4,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'மூட்டுவலி',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'ஞமலி',
            row: 0,
            col: 3
        },
        '3': {
            answer: 'வல்வை',
            row: 2,
            col: 2
        },
        '4': {
            answer: 'மையம்',
            row: 2,
            col: 4
        }
    }
  },
// 193 - 24/09/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'மெய்நிகர்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'தகப்பன்',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'பால்',
            row: 3,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'மெத்தனம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'நிலைப்பாடு',
            row: 0,
            col: 2
        },
        '4': {
            answer: 'பல்',
            row: 2,
            col: 3
        }
    }
  },
// 194 - 25/09/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'மொட்டைமாடி',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'பழைமை',
            row: 2,
            col: 2
        },
        '4': {
            answer: 'போட்டி',
            row: 3,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'மொழிப்போர்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'மாமழை',
            row: 0,
            col: 3
        },
        '3': {
            answer: 'படிமை',
            row: 2,
            col: 2
        }
    }
  },
// 195 - 26/09/2022
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'மோதிரம்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'நீலவானம்',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'முகந்து',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'மோர்நீர்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'ஐம்பது',
            row: 1,
            col: 4
        },
        '4': {
            answer: 'வாழ்க',
            row: 2,
            col: 2
        }
    }
  },
  
  // 196 - 30/09/2022
{
    author: 'முகுந்தன் (சிங்கப்பூர்)',
    theme: 'பொன்னியின் செல்வன்',
    across: {
        '1': {
            answer: 'கரிகாலன்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'பூங்குழலி',
            row: 3,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'கடம்பூர்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'ஈழம்',
            row: 2,
            col: 3
        }
    }
  },
// 197 - 01/10/2022
{
    author: 'முகிலன் முருகன்',
    theme: 'பொன்னியின் செல்வன்',
    across: {
        '3': {
            answer: 'ஆதித்தன்',
            row: 2,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'நந்தினி',
            row: 0,
            col: 1
        },
        '2': {
            answer: 'குந்தவை',
            row: 0,
            col: 3
        }
    }
  },
// 198 - 02/10/2022
{
    author: 'முகிலன் முருகன்',
    theme: 'பொன்னியின் செல்வன்',
    across: {
        '1': {
            answer: 'மணிமேகலை',
            row: 0,
            col: 0
        },
        '5': {
            answer: 'மாதோட்டம்',
            row: 3,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'மலையமான்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'கரை',
            row: 0,
            col: 3
        },
        '3': {
            answer: 'கோட்டை',
            row: 2,
            col: 2
        },
        '4': {
            answer: 'நம்பி',
            row: 2,
            col: 4
        }
    }
  },
// 199
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'வகுத்தல்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'கடிகாரம்',
            row: 2,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'வடிகட்டு',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'தகரம்',
            row: 0,
            col: 3
        },
        '4': {
            answer: 'காதல்',
            row: 2,
            col: 2
        }
    }
  },
  // 200
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'வாக்காளர்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'புரதம்',
            row: 2,
            col: 0
        },
        '5': {
            answer: 'பூச்சி',
            row: 4,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'வான்புகழ்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'காகிதப்பூ',
            row: 0,
            col: 2
        },
        '4': {
            answer: 'பசி',
            row: 3,
            col: 4
        }
    }
  },
 // 201
 {
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'விடுதலை',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'படிகநிலை',
            row: 3,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'விருப்பம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'தடங்கல்',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'கவலை',
            row: 1,
            col: 4
        }
    }
  },
// 202
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'வீடுவாசல்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'கடற்படை',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'கடிதம்',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'வீக்கம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'வாசற்படி',
            row: 0,
            col: 2
        }
    }
  },
// 203
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'வெகுதூரம்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'காவற்படை',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'அம்மி',
            row: 4,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'வெங்காயம்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'படம்',
            row: 2,
            col: 3
        }
    }
  },
// 204
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'வேட்பாளர்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'பந்து',
            row: 2,
            col: 2
        },
        '5': {
            answer: 'மேம்பாடு',
            row: 4,
            col: 1
        }
    },
    down: {
        '1': {
            answer: 'வேறுபாடு',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'பாடுபடும்',
            row: 0,
            col: 2
        },
        '4': {
            answer: 'துண்டு',
            row: 2,
            col: 4
        }
    }
  },
  // 205
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'அணுகுண்டு',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'முற்பகல்',
            row: 3,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'அணுகுமுறை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'குடும்பம்',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'கல்வி',
            row: 2,
            col: 4
        }
    }
  },
  // 206
  {
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'அமைச்சர்',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'சிலம்பம்',
            row: 2,
            col: 0
        },
        '4': {
            answer: 'எதிரி',
            row: 4,
            col: 2
        }
    },
    down: {
        '1': {
            answer: 'அரசியல்',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'சமபகுதி',
            row: 0,
            col: 3
        }
    }
  },
   // 207
   {
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'அதிர்ச்சி',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'வகுப்பறை',
            row: 3,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'அதிர்வலை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'சில்லறை',
            row: 0,
            col: 4
        },
        '3': {
            answer: 'குப்பை',
            row: 2,
            col: 2
        }
    }
  },
// 208
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'அப்பொழுது',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'பொதுவிடம்',
            row: 2,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'அப்பொழிவு',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'பொன்விழா',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'துரும்பு',
            row: 0,
            col: 4
        }
    }
  },
// 209
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'அன்புடைமை',
            row: 0,
            col: 0
        },
        '3': {
            answer: 'துறவி',
            row: 2,
            col: 2
        },
        '5': {
            answer: 'மைதானம்',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'அருளுடைமை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'புதிது',
            row: 0,
            col: 2
        },
        '4': {
            answer: 'விதை',
            row: 2,
            col: 4
        }
    }
  },
// 210
{
    author: 'முகிலன் முருகன்',
    across: {
        '1': {
            answer: 'அறிவிப்பு',
            row: 0,
            col: 0
        },
        '4': {
            answer: 'வாத்து',
            row: 2,
            col: 2
        },
        '5': {
            answer: 'மைத்துணர்',
            row: 4,
            col: 0
        }
    },
    down: {
        '1': {
            answer: 'அறிவுடைமை',
            row: 0,
            col: 0
        },
        '2': {
            answer: 'விரிவானது',
            row: 0,
            col: 2
        },
        '3': {
            answer: 'புத்துயிர்',
            row: 0,
            col: 4
        }
    }
  },
// 
];

export default crosswords;